let loadedGtmId: string | null = null;

export function loadGTM(gtmId: string): Promise<void> {
   if (loadedGtmId === gtmId) return Promise.resolve();

   loadedGtmId = gtmId;

   (window as any).dataLayer = (window as any).dataLayer || [];
   (window as any).dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

   return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error(`Failed to load GTM: ${gtmId}`));
      document.head.insertBefore(script, document.head.firstChild);

      const noscript = document.createElement('noscript');
      noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
      document.body.insertBefore(noscript, document.body.firstChild);
   });
}
